import { render, staticRenderFns } from "./CompaniesView.vue?vue&type=template&id=c5dc8d2e&"
import script from "./CompaniesView.vue?vue&type=script&lang=js&"
export * from "./CompaniesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports